import { Pipe, PipeTransform } from '@angular/core';
import { Observable, map } from 'rxjs';

import { ConfigResolverService } from './config-resolver.service';

@Pipe({
  name: 'configLabel',
  standalone: true,
})
export class ConfigLabelPipe implements PipeTransform {
  constructor(private configResolver: ConfigResolverService) {}
  transform(
    value: string,
    labelId: string,
    portalId: number | null | undefined
  ): Observable<string> {
    return this.configResolver
      .resolveLabelName(labelId, portalId)
      .pipe(map((resolvedValue) => resolvedValue ?? value));
  }
}
